import 'owl.carousel2/dist/assets/owl.carousel.css';
import 'owl.carousel2/dist/owl.carousel';

$(document).ready(function(){

$('#owl-two').owlCarousel({
      items: 1,
      center: true,
      loop: true,
      margin: 10,
      dots: true,
      autoplay: true,
      lazyLoad: true,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      rewind: true,
    });

  var _news = function () {

    let paginate = function (resetPagination) {

      let filters_form = $('.c-news__filters-form')

      let input_page = filters_form.find('input[name="page"]')

      if(resetPagination) {
        input_page.val(1)
      }else {
        input_page.val(parseInt(input_page.val()) + 1)
      }

      let ajaxRequest= $.ajax({
        url: "/getNews",
        type: "GET",
        data: filters_form.serialize()
      })

      ajaxRequest.done(function (response, textStatus, jqXHR){
        let news = response.news.data
        let newsHtml = ''

        $.each(news, function() {
          newsHtml += '<li>\n' +
            '<a href="'+this.route+'"><h3>'+this.title+'</h3></a>\n' +
            '<span>'+this.postDate+'</span>\n' +
            '<a href="'+this.route+'"><img src="'+this.image_full_path+'" alt="'+this.title+'" class="img-fluid"></a>\n' +
            '<p>'+this.short_description+'</p>\n' +
            '<a href="'+this.route+'" class="c-news__list-detail-button"><strong>Leia mais</strong></a>\n' +
            '</li>'
        })

        if(response.news.current_page === 1) {
          $('.c-news__list').html(newsHtml)
        }else{
          $('.c-news__list').append(newsHtml)
        }

        if(response.news.last_page === response.news.current_page) {
          $('.c-news__more-news-button').hide()
          $('.c-news__list').append('<h3 class="text-center">Não há mais novidades.</h3>')
        }else {
          $('.c-news__more-news-button').show()
        }

        if(response.news.current_page > response.news.last_page) {
          $('.c-news__more-news-button').hide()
          input_page.val(response.news.last_page)
          $('.c-news__list').append('<h3 class="text-center">Não há mais novidades.</h3>')
        }

      })

      /*/!* On failure of request this function will be called  *!/*/
      ajaxRequest.fail(function (){
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: 'Aconteceu algo errado, por favor, tente novamente. Se o erro persistir, entre em contato conosco.',
        })
      })
    }

    let getNewsWithFilter = function (e) {
      e.preventDefault()
      paginate(true)
    }

    return {
      paginate: paginate,
      getNewsWithFilter: getNewsWithFilter
    }

    
  }
  News = _news()


});
